<!--
 * @Author: your name
 * @Date: 2021-05-14 10:10:58
 * @LastEditTime: 2021-08-05 16:35:10
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \nqc-pc-ui\src\common\components\LineSelect\index.vue
 * @from  参考 https://blog.csdn.net/weixin_44981586/article/details/107317544
-->
<template>
  <div>
    <el-tree
      ref="tree"
      :indent="0"
      :data="showData"
      :props="defaultProps"
      :default-expanded-keys="defaultExpandRow"
      :expand-on-click-node="false"
      check-strictly
      default-expand-all
      node-key="mgmtUnitCode"
      class="tree-container"
      @node-click="nodeClick"
    >
      <div slot-scope="{ node, data }" class="custom-tree-node">
        <div>
          <span style="position: relative">
            <i
              :class="
                data.childs && data.childs.length > 0 ? '' : 'wn-noChilds'
              "
              class="wn-icon"
            />
            <el-checkbox
              v-if="showCheckbox"
              v-model="data.isCheked"
              @change.self="getCheckedList(data)"
            />
            <span>{{ node.label }}</span>
          </span>
        </div>
      </div>
    </el-tree>
  </div>
</template>
<script>
export default {
  name: 'LineSelect',
  model: {
    prop: 'selectData',
    event: 'change'
  },
  props: {
    queryType: {
      type: Number,
      default: 1
    },
    firstDefault: {
      type: Boolean,
      default: false
    },
    showCheckbox: {
      type: Boolean,
      default: false
    },
    selectedList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      defaultProps: {
        label: 'mgmtUnitName',
        value: 'mgmtUnitCode',
        children: 'childs'
      },
      defaultExpandRow: [],
      showData: []
    }
  },
  watch: {
    selectedList: {
      handler(val, oval) {
        if (this.showData.length > 0) {
          this.selectedList = val
          this.filterData(this.showData)
        }
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    this.getDataList()
  },
  methods: {
    async getDataList() {
      if (this.queryType === 1) {
        await this.$store
          .dispatch('orgStructure/findManageQcUnitByManageStaff', {
            HospitalCode:
              this.$store.state.user.userContextHospital.HospitalCode,
            staffCode: this.$store.state.user.loginUserInfo.userDto.staffCode
          })
          .then((res) => {
            this.showData = [...res]
            this.filterData(this.showData)
            if (this.firstDefault) {
              this.$nextTick(() => {
                this.$refs.tree.setCheckedKeys([this.showData[0].mgmtUnitCode])
                this.$emit('change', [this.showData[0]])
              })
            }
          })
      } else if (this.queryType === 0) {
        await this.$store
          .dispatch('orgStructure/queryPagedOrgStructureByParams', {
            current: 1,
            size: -1,
            condition: {
              HospitalCode: this.HospitalCode
            }
          })
          .then((res) => {
            // 获取当前处于发布状态的行政组织结构.
            if (!this.currSelectOrgStructure) {
              const orgStructures = res.records
              const orgStructureToSelected = orgStructures.find(
                (item) => item.pubStatus === '2' && item.structureType === '4'
              )
              this.loadTreeList(orgStructureToSelected)
            }
          })
      }
    },
    loadTreeList(orgStructureToSelected) {
      this.$store
        .dispatch('organization-manage/findOrgStructureNodeTree', {
          query: {
            orgStructureId: orgStructureToSelected.id
          }
        })
        .then((res) => {
          this.showData = [...res]
          this.filterData(this.showData)
          if (this.firstDefault) {
            this.$nextTick(() => {
              this.$refs.tree.setCheckedKeys([this.showData[0].mgmtUnitCode])
              this.$emit('change', [this.showData[0]])
            })
          }
        })
        .catch((err) => {
          this.$eventBus.$emit('SHOW_SERVER_ERROR_500', err)
        })
    },
    // 格式化数据
    filterData(data) {
      if (data && data.length > 0) {
        if (this.selectedList.length > 0) {
          data.forEach((item) => {
            const selectedIndex = this.selectedList.findIndex(
              (list) => list.manageUnitCode === item.mgmtUnitCode
            )
            if (selectedIndex > -1) {
              this.$set(item, 'isCheked', true)
            } else {
              this.$set(item, 'isCheked', false)
            }
            if (item.childs && item.childs.length > 0) {
              this.filterData(item.childs)
            }
          })
        } else {
          data.forEach((item) => {
            this.$set(item, 'isCheked', false)
            if (item.childs && item.childs.length > 0) {
              this.filterData(item.childs)
            }
          })
        }
      }
    },
    nodeClick(data, checked, node) {
      this.$set(data, 'open', !data.open)
      this.$emit('change', [data])
    },
    // getCheckedNodes() {
    //   const selectedNode = this.$refs.tree.getCheckedNodes();
    //   this.$emit("change", selectedNode);
    // },
    getCheckedList(data) {
      const selectData = { ...data }
      this.$emit('getSelectUnit', selectData)
    }
  }
}
</script>
<style lang="scss" scoped>
.tree-container /deep/ {
  .el-tree-node {
    position: relative;
    padding-left: 16px; // 缩进量
  }
  .el-tree-node__children {
    padding-left: 16px; // 缩进量
  }

  // 竖线
  .el-tree-node::before {
    content: '';
    height: 100%;
    width: 1px;
    position: absolute;
    left: -3px;
    top: 0px;
    border-width: 1px;
    border-left: 1px dashed #c6c6c6;
  }
  // 当前层最后一个节点的竖线高度固定
  .el-tree-node:last-child::before {
    height: 38px; // 可以自己调节到合适数值
  }
  // 自定义图标 原图标隐藏
  .el-icon-caret-right:before {
    // visibility: hidden;
    content: url('../../assets/images/minus.png');
    // border: 1px solid #c9c9c9;
    // z-index: 999999;
    // padding: 1px;
  }
  .expanded:before {
    // visibility: hidden;
    content: url('../../assets/images/plus.png');
  }
  .el-tree-node__expand-icon.expanded {
    transform: none;
  }

  // 横线
  //   .el-tree-node::after {
  //     content: "";
  //     width: 24px;
  //     height: 20px;
  //     position: absolute;
  //     left: -3px;
  //     top: 12px;
  //     border-width: 1px;
  //     border-top: 1px dashed #52627C;
  //   }

  // 去掉最顶层的虚线，放最下面样式才不会被上面的覆盖了
  & > .el-tree-node::after {
    border-top: none;
  }
  & > .el-tree-node::before {
    border-left: none;
  }

  // 展开关闭的icon
  .el-tree-node__expand-icon {
    font-size: 16px;
    // 叶子节点（无子节点）
    &.is-leaf {
      color: transparent;
      // display: none; // 也可以去掉
    }
  }
}
.wn-icon {
  position: absolute;
  top: 0px;
  left: -25px;
  z-index: 999;
  font-size: 16px;
  color: #c9c9c9;
  font-weight: 500;
  text-align: center;
}
.wn-noChilds {
  &:after {
    content: '';
    width: 1px;
    height: 10px;
    display: inline-block;
    border-left: 1px dashed #c6c6c6;
    position: absolute;
    right: -11px;
    top: 17px;
  }
  &:last-child:after {
    content: '';
    border: none;
  }
}
</style>
